import React from 'react'
import Header from './Header'
import Footer from './Footer'
import { NavHashLink as NavLink } from 'react-router-hash-link'
class PrivacyPolicy extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {
        return (
            <main className="job">
                <Header />
                <section className="subheader">
                    <div className="filter-seyte">
                        <h1>Política de privacidad</h1>
                    </div>
                </section>
                <section className="content">
                    <p>
                        <span>
                            Nos tomamos muy en serio su privacidad. Estamos comprometidos a salvaguardar su privacidad y esta Política de Privacidad explica nuestras prácticas en
                            la recogida, tratamiento y divulgación de sus datos. La siguiente información es aplicable a todas las plataformas que utilizamos para prestar nuestros
                            servicios. Al enviarnos sus datos y/o al utilizar nuestro Sitio Web usted dará su consentimiento expreso para que utilicemos sus datos personales, en
                            los términos descritos en esta Política de Privacidad. Si no acepta la Política de Privacidad, no utilice el Sitio Web ni nos proporcione sus datos
                            personales.
                        </span>
                    </p>
                    <p>
                        <h3>Recopilación y uso de la información.</h3>
                    </p>
                    <p>
                        <span>
                            De conformidad con el Artículo 5 de la Ley Orgánica 15/1999, de 13 de diciembre, de Protección de Datos de Carácter Personal (en adelante, LOPD), le
                            informamos que la cumplimentación de cualquier formulario existente en nuestro Sitio Web, o la remisión de un correo electrónico a cualquiera de
                            nuestros buzones, implica la aceptación de esta Política de Privacidad, así como la autorización para que tratemos los datos personales que nos
                            facilite, los cuales serán incorporados a los ficheros responsabilidad de{' '}
                        </span>
                        <span>Servicios Empresariales y Tecnológicos Integrados, S.L. </span>
                        <span>
                            con las siguientes finalidades: (i) responder su consulta; (ii) garantizar la adecuada prestación del servicio solicitado; (iii) gestionar nuestra
                            agenda de contactos, clientes y/o proveedores; (iv) gestionar incidencias y modificaciones; (v) informar sobre nuestros servicios, novedades y/o
                            ofertas; (vi) dar cumplimiento a los requisitos relativos a la contabilidad, facturación y auditoría de los servicios contratados; y/o (vii) dar
                            cumplimiento a los requisitos de seguridad, administración y jurídicos de la empresa.
                        </span>
                    </p>
                    <p>
                        <span>
                            Tanto si contrata nuestros servicios como si no, usted nos autoriza mediante este documento al mantenimiento de sus datos personales en nuestros
                            ficheros, con la finalidad de ponernos en contacto con usted en el futuro, para ofertarle los mismos servicios o nuevos que hayamos incorporado a
                            nuestra línea de negocio, y salvo que nos comunique lo contrario, para el envío de boletines de noticias (newsletter) y comunicaciones comerciales, por
                            cualquier medio, sobre los productos y servicios de nuestra empresa.
                        </span>
                    </p>
                    <p>
                        <h3>Veracidad de la información</h3>
                    </p>
                    <p>
                        <span>
                            Usted es responsable de la veracidad de la información facilitada y usted es responsable de comunicar cualquier modificación, y por lo tanto, nosotros
                            no seremos responsables de la inexactitud de los datos personales proporcionados.
                        </span>
                    </p>
                    <p>
                        <span>
                            Si usted nos facilita datos personales de un tercero, o nos los facilita en un futuro, con carácter previo a su inclusión, usted deberá haberle
                            informado y solicitado su consentimiento, y por lo tanto, no asumimos ninguna responsabilidad en este sentido.
                        </span>
                    </p>
                    <p>
                        <h3>Derechos de acceso, rectificación, cancelación y oposición.</h3>
                    </p>
                    <p>
                        <span>Usted puede ejercer, en cualquier momento, los derechos de acceso, rectificación, cancelación y oposición dirigiéndose </span>
                        <span>mediante comunicación escrita a </span>
                        <span>Servicios Empresariales y Tecnológicos Integrados, S.L&nbsp;Calle Costa Balear, n&ordm;24, Portal 1, 3&ordm;A, Almería, Espa&ntilde;a, 04009</span>
                    </p>
                    <p>
                        <h3>Intercambio y divulgación de la información.</h3>
                    </p>
                    <p>
                        <span>
                            Debido a la naturaleza global de Internet, su uso para obtener y procesar datos personales puede implicar la transferencia de datos a escala
                            internacional. Por consiguiente, al utilizar nuestro Sitio Web y/o comunicarse electrónicamente con nosotros, usted acepta que nosotros (o proveedores o
                            subcontratistas) podamos procesar sus datos personales a escala internacional. No obstante, nuestra política de empresa es tratar de procesar todos sus
                            datos personales dentro del territorio del Espacio Económico Europeo.
                        </span>
                    </p>
                    <p>
                        <span>
                            No alquilaremos, venderemos y/o compartiremos su información confidencial con terceros, excepto en las siguientes circunstancias: (i) cuando tengamos su
                            autorización; (ii) cuando precisemos compartir su información para proporcionarle el producto o servicio que usted haya solicitado; (iii) cuando nuestra
                            empresa resulte adquirida por otra empresa o se fusione con otra empresa; (iv) cuando debamos atender a una citación judicial, resolución de un juez o
                            tribunal o a un procedimiento judicial, o debamos establecer o ejercer los derechos jurídicos que nos correspondan o defendernos contra demandas
                            judiciales; y/o (v) cuando consideremos necesario compartir información con el fin de prevenir, detectar o perseguir actos criminales.
                        </span>
                    </p>
                    <p>
                        <span>
                            Puede también que generemos en forma conjunta información personal de nuestros usuarios y que proporcionemos esta información en conjunto a otras
                            terceras partes, incluso anunciantes e inversores (en este caso los datos se tratarán de forma despersonalizada).
                        </span>
                    </p>
                    <p>
                        <span>
                            También podemos divulgar su información de carácter personal a cualquier miembro de nuestro grupo, lo que incluye también a nuestras subsidiarias y a
                            nuestra sociedad matriz principal y a sus subsidiarias.
                        </span>
                    </p>
                    <p>
                        <h3>Seguridad y privacidad.</h3>
                    </p>
                    <p>
                        <span>
                            La protección de su información personal es una prioridad para nosotros. Empleamos las medidas de seguridad razonables para proteger su información
                            personal frente a la pérdida, robo, acceso no autorizado, divulgación, copia, uso inadecuado o modificación.
                        </span>
                    </p>
                    <p>
                        <span>
                            Aunque tratamos de hacer todo lo posible para proteger su información personal, la transmisión de información a través de Internet no es completamente
                            segura. Por lo tanto, no podemos asegurarle o garantizarle la seguridad de ninguna información que nos transmita. Usted acepta las consecuencias
                            inherentes de seguridad derivadas del uso de Internet y no nos hará responsables de cualquier brecha de seguridad. Concretamente, el acceso a nuestro
                            Sitio Web y el uso de éste por su parte corre únicamente a su cuenta y riesgo, y usted es responsable de restringir el acceso a su ordenador y de
                            asegurarse de que éste está completamente limpio de todo tipo de códigos maliciosos, spyware, virus, troyanos, etcétera, que puedan seguir los datos que
                            introduces en nuestro Sitio Web.
                        </span>
                    </p>
                    <p>
                        <h3>Uso de cookies.</h3>
                    </p>
                    <p>
                        <span>
                            Utilizamos cookies y tecnologías similares para asegurarnos de que tenga la mejor experiencia posible en nuestro Sitio Web. Puede obtener más
                            información en nuestra{' '}
                            <NavLink smooth to="/politica-de-cookies">
                                Política de Cookies.
                            </NavLink>
                        </span>
                    </p>
                    <p>
                        <h3>Enlaces externos.</h3>
                    </p>
                    <p>
                        <span>
                            Si alguna parte de nuestro Sitio Web le conecta con otros sitios, esos sitios no operan según esta Política de Privacidad. Le recomendamos examinar las
                            declaraciones de privacidad publicadas en estos otros sitios para comprender sus procedimientos para recopilar, utilizar y divulgar información
                            personal.
                        </span>
                    </p>
                    <p>
                        <h3>Cambios en nuestra Política de Privacidad.</h3>
                    </p>
                    <p>
                        <span>
                            Nos reservamos el derecho a modificar la presente Política de Privacidad en cualquier momento y sin previo aviso. Por lo tanto, usted es el responsable
                            de repasar con frecuencia esta Política de Privacidad. Si continuas utilizando nuestro Sitio Web o los servicios prestados por nuestra empresa una vez
                            que los cambios se hayan realizado, se entenderá que estás conforme con la nueva Política de Privacidad.
                        </span>
                    </p>
                    <p>
                        <span>Si tiene alguna pregunta sobre esta Política de Privacidad, por favor contáctenos.</span>
                    </p>
                </section>
                <Footer />
            </main>
        )
    }
}

export default PrivacyPolicy



// WEBPACK FOOTER //
// ./src/components/PrivacyPolicy.js